<template>
    <div>
    </div>
</template>

<script>
import {wechatlogin_url , ali_login_url} from '@/request/api.js'
export default {
    name: 'NewLiuyanShopWebOtherlogin',
    data() {
        return {
            
        };
    },

    mounted() {
    },

    methods: {
        
    },
    created(){
        var url=window.location.href;
        // 支付宝登录
       if(url.indexOf('alipay')!=-1){
           ali_login_url({data:url}).then((res)=>{
               if(res.data.code === 200 ){
                    let token = res.data.data.token
                    let tokenDate = new Date().getTime();
                    this.$cookies.set('tokenDate', tokenDate,3600);
                    localStorage.setItem('userToken', token);
                    this.$store.dispatch('setLogin', token);
                    this.$message.success('登录成功');
                    this.$store.dispatch('getCarCount');
                    this.$router.push({path: '/Information'}) 
               }else{
                    this.$message.success('登录失败');
                    this.$router.push({path: '/Login'})
               }
           })
       }else{
        //    微信登录
           wechatlogin_url({data:url}).then((res)=>{
               if(res.data.code === 200 ){
                    let token = res.data.data.token
                    let tokenDate = new Date().getTime();
                    if(res.data.data.wechat_phone == '1'){
                    //请求成功保存用户登录信息到localStorage和Vuex中
                        this.$cookies.set('tokenDate', tokenDate,3600);
                        localStorage.setItem('userToken', token);
                        this.$store.dispatch('setLogin', token);
                        this.$message.success('登录成功');
                        this.$store.dispatch('getCarCount');
                        this.$router.push({path: '/Information'})
                    }else if(res.data.data.wechat_phone == '0'){
                        this.$message.success('请绑定手机号');
                        this.$cookies.set('tokenDate', tokenDate,3600);
                        localStorage.setItem('userToken', token);
                        this.$router.push({path: '/binding'})
                    }
               }else{
                    this.$message.success('登录失败');
                    this.$router.push({path: '/Login'})
               }
           })
       }
    }
};
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/view/otherLogin.vue